import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../models/table-column';
import { getColumnsChronoStandard, getTableColumns } from './table-columns';
import { DayCheckModel } from '../../models/day-info/day-check.model';
import { SessionQuery } from '../session/session.query';
import { ViewStates } from '../../enums/day-info-view-states.enum';
import * as moment from 'moment-timezone';
import { TIMEZONE } from '../../services/language.service';
import {
  ChronoVersionEnum,
  Saldo,
  VisumCheck,
  VisumListItem,
} from '../../models/client-models';
import { DateRange } from '../../models/date-range';

export interface DayInfoState {
  saldo: Saldo;
  selectedDateRange: DateRange;
  tableColumns: TableColumn[];
  dateVisumInfo: VisumCheck;
  dayCheck: DayCheckModel;
  currentVisum: VisumListItem;
  viewState: ViewStates;
}

export const createInitialState = (
  sessionQuery: SessionQuery
): DayInfoState => {
  let columns: TableColumn[];
  if (sessionQuery.getChronoVersion() == ChronoVersionEnum.Standard) {
    columns = getColumnsChronoStandard();
  } else {
    columns = getTableColumns();
  }
  return {
    saldo: {} as Saldo,
    selectedDateRange: {
      start: moment.tz(moment(), TIMEZONE).format(),
      end: moment.tz(moment(), TIMEZONE).format(),
    } as DateRange,
    tableColumns: columns,
    dateVisumInfo: {
      hasVisum: false,
    } as VisumCheck,
    dayCheck: {
      insideLockDate: false,
      yearOpen: true,
    },
    currentVisum: {} as VisumListItem,
    viewState: ViewStates.Combined,
  };
};

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'dayInfoPage' })
export class DayInfoStore extends Store<DayInfoState> {
  constructor(private sessionQuery: SessionQuery) {
    super(createInitialState(sessionQuery));
  }
}
